<template>
    <div
        v-if="conditionallyActive(field, path)"
        class="fin-relative"
        :class="!['inputGroup', 'pageColumns'].includes(field.type) ? 'fin-mb-3' : ''"
        :key="fieldKey">
        <slot/>
    </div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"
export default {
    name: "FieldGroup",
    props: {
        field: {
            required: false,
            type: Object,
        },
        fieldKey: {
            required: true,
            type: [Number, String],
        },
        path: {
            required: false
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },
    mixins: [formMixin],
}
</script>
